/* ============================================================
   JB PDP COLORWAY STRIP
   File: /assets/jb-pdp-colorway-strip.js
   Theme: Horizon (Copy of Horizon)
   Purpose: Render a labeled thumbnail strip of all color
            variants below the product gallery on the PDP.
            Clicking a thumb selects that variant via the
            existing color radio (Horizon then swaps the
            main image natively).
   ============================================================ */

(function () {
  'use strict';

  function isPdp() {
    const main = document.querySelector('main[data-template="product"]');
    if (main) return true;
    if (document.body && /\btemplate-product\b/.test(document.body.className)) return true;
    return /\/products\//.test(window.location.pathname);
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getColorRadios() {
    const candidates = [];
    const headings = document.querySelectorAll('legend, .variant-picker__option-name, .variant-option__name, [class*="variant"] h3, [class*="variant"] h4');
    for (const h of headings) {
      const txt = (h.textContent || '').trim().toLowerCase();
      if (txt === 'color' || txt.startsWith('color:') || txt.startsWith('color ')) {
        let container = h.closest('fieldset') || h.closest('.variant-picker__option') || h.parentElement;
        if (container) {
          const inputs = container.querySelectorAll('input[type="radio"]');
          if (inputs.length) {
            inputs.forEach(i => candidates.push(i));
            break;
          }
        }
      }
    }
    if (!candidates.length) {
      const all = document.querySelectorAll('input[type="radio"]');
      all.forEach(i => {
        const v = (i.value || '').toLowerCase();
        if (/bourbon|barrel|aged|whiskey|cream|charcoal|oak|wash|black/.test(v)) {
          candidates.push(i);
        }
      });
    }
    const seen = new Set();
    return candidates.filter(i => {
      const k = i.value || i.id;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  function getProductJson() {
    const sels = [
      'script[type="application/json"][data-product-json]',
      'script[type="application/json"].product-json',
      'script[type="application/json"][id*="product"]',
      'script[type="application/json"][data-product]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (!el) continue;
      try {
        const j = JSON.parse(el.textContent);
        if (j && (j.variants || j.id)) return j;
      } catch (e) {}
    }
    const all = document.querySelectorAll('script[type="application/json"]');
    for (const el of all) {
      try {
        const j = JSON.parse(el.textContent);
        if (j && Array.isArray(j.variants) && j.variants[0] && j.variants[0].option1) {
          return j;
        }
      } catch (e) {}
    }
    return null;
  }

  function buildColorMap(product) {
    const map = {};
    if (!product || !Array.isArray(product.variants)) return map;
    let colorIdx = 0;
    if (Array.isArray(product.options)) {
      for (let i = 0; i < product.options.length; i++) {
        const o = product.options[i];
        const name = typeof o === 'string' ? o : (o && o.name);
        if (name && name.toLowerCase().includes('color')) { colorIdx = i; break; }
      }
    }
    const optKey = 'option' + (colorIdx + 1);
    for (const v of product.variants) {
      const colorName = v[optKey];
      if (!colorName || map[colorName]) continue;
      let img = v.featured_image && (v.featured_image.src || v.featured_image);
      if (img && typeof img === 'string' && img.indexOf('//') === 0) img = 'https:' + img;
      if (!img && product.featured_image) {
        img = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      }
      if (img) map[colorName] = img;
    }
    return map;
  }

  function findGalleryHost() {
    const sels = [
      '.product-media-gallery',
      '[class*="product-media-gallery"]',
      '[class*="product__media"]',
      'product-media-gallery',
      '.product-gallery'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  function buildStrip(radios, colorMap) {
    const wrap = document.createElement('div');
    wrap.className = 'jb-colorway-strip';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Color options');

    radios.forEach(input => {
      const colorName = input.value;
      const img = colorMap[colorName];
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'jb-colorway-strip__item';
      item.setAttribute('data-color', colorName);
      if (input.checked) item.classList.add('is-selected');
      item.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      item.setAttribute('aria-label', 'Select ' + colorName);

      const imgWrap = document.createElement('span');
      imgWrap.className = 'jb-colorway-strip__img';
      if (img) {
        const i = document.createElement('img');
        i.src = img;
        i.alt = colorName + ' hoodie';
        i.loading = 'lazy';
        i.decoding = 'async';
        imgWrap.appendChild(i);
      }

      const label = document.createElement('span');
      label.className = 'jb-colorway-strip__label';
      label.textContent = colorName;

      item.appendChild(imgWrap);
      item.appendChild(label);

      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          const lbl = input.closest('label');
          if (lbl) lbl.click();
        }
        wrap.querySelectorAll('.jb-colorway-strip__item').forEach(it => {
          const sel = it === item;
          it.classList.toggle('is-selected', sel);
          it.setAttribute('aria-pressed', sel ? 'true' : 'false');
        });
      });

      wrap.appendChild(item);
    });

    return wrap;
  }

  function sync(wrap, radios) {
    let checkedVal = null;
    for (const r of radios) {
      if (r.checked) { checkedVal = r.value; break; }
    }
    if (!checkedVal) return;
    wrap.querySelectorAll('.jb-colorway-strip__item').forEach(it => {
      const sel = it.getAttribute('data-color') === checkedVal;
      it.classList.toggle('is-selected', sel);
      it.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
  }

  function init() {
    if (!isPdp()) return;

    const radios = getColorRadios();
    if (!radios.length) return;
    if (radios.length < 2) return;

    const product = getProductJson();
    const colorMap = buildColorMap(product);

    if (document.querySelector('.jb-colorway-strip')) return;

    const gallery = findGalleryHost();
    if (!gallery) return;

    const strip = buildStrip(radios, colorMap);
    gallery.parentNode.insertBefore(strip, gallery.nextSibling);

    const syncDeb = debounce(() => sync(strip, radios), 50);
    radios.forEach(r => r.addEventListener('change', syncDeb));
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio' && radios.indexOf(e.target) !== -1) syncDeb();
    }, true);
  }

  function bootstrap() {
    init();
    const main = document.querySelector('main') || document.body;
    let last = 0;
    const obs = new MutationObserver(debounce(function () {
      const now = Date.now();
      if (now - last < 200) return;
      last = now;
      if (!document.querySelector('.jb-colorway-strip')) init();
    }, 150));
    obs.observe(main, { childList: true, subtree: true });
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:block:select', init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
